const release = "vde8-tibi-2023.r270-heads-master-0-g62bc1aa"
const apiClientBaseURL = "/api/"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}

module.exports = {
    release,
    apiClientBaseURL,
}
